export default (client, defaultParams) => ({
  remove: (id) => (
    client(`/gdrive/file/${id}`, {
      method: 'DELETE',
      params: {
        ...defaultParams,
      },
    })
  ),
  changeTitle: (id, title) => (
    client(`/gdrive/file/${id}/title/${title}`, {
      method: 'PUT',
      params: {
        ...defaultParams,
      },
    })
  ),

  getMessage: (k) => {
    const messages = {
    };
    return (messages[k] || k);
  },
});
